export enum ButtonSize {
    Default = "Default",
    Small = "Small",
    Big = "Big"
}